/**
 * Where a listing lives, in one place.
 *
 * The counterpart of `backend/property_slugs.py`. The backend decides the
 * slug and stores it; this only chooses between the slug and the id, so
 * there is no algorithm here to drift out of step with Python's.
 *
 * `website_slug` is absent on a listing saved before slugs existed and on
 * anything the projection has not been widened for, so the id is always the
 * fallback and always resolves: the public route accepts the id, the current
 * slug and every slug the listing has ever had.
 */
export function propertySlug(property) {
  return (property?.website_slug || property?.id || "").trim();
}

export function propertyPath(property) {
  const key = propertySlug(property);
  return key ? `properties/${key}` : "properties";
}
